export function pickupBusiness(pickupBusinessId) {
  localStorage.setItem('rentPickupBusinessId', pickupBusinessId);
}
export function pickupDate(pDate) {
  localStorage.setItem('rentPickupDate', pDate);
}

export function pickupTime(pTime) {
  localStorage.setItem('rentPickupTime', pTime);
}

export function dropBusiness(dropBusinessId) {
  localStorage.setItem('rentDropBusinessId', dropBusinessId);
}

export function dropDate(dDate) {
  localStorage.setItem('rentDropDate', dDate);
}

export function dropTime(dTime) {
  localStorage.setItem('rentDropTime', dTime);
}

export function vehicle(vehicleID) {
  localStorage.setItem('rentVehicle', vehicleID);
}

export function oneWay(isOneWay) {
  localStorage.setItem('oneWay', isOneWay);
}

export function user(userInfo) {
  localStorage.setItem('localUser', userInfo);
}

export function accessToken(pAccessToken) {
  localStorage.setItem('accessToken', pAccessToken);
}

export function refreshToken(pRefreshToken) {
  localStorage.setItem('refreshToken', pRefreshToken);
}

export function additionnalDrivers(idsArray) {
  localStorage.setItem('additionnalDrivers', idsArray);
}

export function isLightSignUp(value) {
  localStorage.setItem('isLightSignUp', value);
}

export function signupOrigin(origin) {
  localStorage.setItem('signupOrigin', origin)
}

export function cdw(value) {
  localStorage.setItem('cdw', value)
}

export function additionnalKms(value) {
  localStorage.setItem('additionnalKms', value)
}
export function coupon(value) {
  localStorage.setItem('coupon', value)
}

export function shownPopinsIds(idsArray) {
  localStorage.setItem('shownPopinsIds', idsArray)
}
export function popinGlobal(value) {
  localStorage.setItem('popinGlobal', value);
}

export function removeCompletedBookingInfo() {
  [
    'rentPickupBusinessId',
    'rentPickupDate',
    'rentPickupTime',
    'rentDropBusinessId',
    'rentDropDate',
    'rentDropTime',
    'rentVehicle',
    'oneWay',
    'additionnalDrivers',
    'isLightSignUp',
    'signupOrigin',
    'cdw',
    'additionnalKms',
  ].forEach((keyName) => localStorage.removeItem(keyName))
}

export function removeSignupOrigin() {
  localStorage.removeItem('signupOrigin');
}

export function clearLocalStorage() {
  localStorage.clear();
}
export default {
  pickupBusiness,
  pickupDate,
  pickupTime,
  dropBusiness,
  dropDate,
  dropTime,
  oneWay,
  accessToken,
  refreshToken,
  removeCompletedBookingInfo,
  removeSignupOrigin,
  additionnalDrivers,
  isLightSignUp,
  signupOrigin,
  shownPopinsIds,
  clearLocalStorage,
  cdw,
  additionnalKms,
  popinGlobal,
};
